<!-- ─── Slide-in panel ─── -->
<div class="fixed top-0 right-0 h-full bg-[#FAFAFA] w-full sm:w-[420px] z-[99999] shadow-2xl flex flex-col
     transition-transform duration-300 ease-in-out"
     [class.translate-x-0]="isOpen"
     [class.translate-x-full]="!isOpen">

  <!-- ─── Header ─── -->
  <div class="flex items-center justify-between px-5 pt-5 pb-0 flex-shrink-0 bg-white border-b border-gray-100">

    <div class="flex items-center gap-1">
      <!-- Notifications tab -->
      <button (click)="activeTab = 'notification'"
        class="relative flex items-center gap-2 px-4 py-3 text-base font-semibold transition-colors duration-200"
        [class.text-[#D31148]]="activeTab === 'notification'"
        [class.text-gray-400]="activeTab !== 'notification'">
        <span>Notifications</span>
        <span *ngIf="unreadCount > 0"
          class="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-[#D31148] text-white text-[10px] font-bold leading-none">
          {{ unreadCount > 99 ? '99+' : unreadCount }}
        </span>
        <span *ngIf="activeTab === 'notification'"
          class="absolute bottom-0 left-0 right-0 h-0.5 bg-[#D31148] rounded-full"></span>
      </button>

      <!-- Friend requests tab -->
      <button (click)="activeTab = 'friend'; loadFriendRequests()"
        class="relative flex items-center gap-2 px-4 py-3 text-base font-semibold transition-colors duration-200"
        [class.text-[#D31148]]="activeTab === 'friend'"
        [class.text-gray-400]="activeTab !== 'friend'">
        <span>Friend Requests</span>
        <span *ngIf="friendCount > 0"
          class="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-[#D31148] text-white text-[10px] font-bold leading-none">
          {{ friendCount }}
        </span>
        <span *ngIf="activeTab === 'friend'"
          class="absolute bottom-0 left-0 right-0 h-0.5 bg-[#D31148] rounded-full"></span>
      </button>
    </div>

    <div class="flex items-center gap-1 pb-2">
      
      <button (click)="closePanel()"
        class="p-2 rounded-lg text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-colors">
        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>
  </div>
<button *ngIf="activeTab === 'notification' && unreadCount > 0"
        (click)="markAllRead()"
        class="text-xs mt-2 font-medium text-[#D31148] hover:text-[#a00f38] px-2 py-1 rounded transition-colors">
        Mark all read
      </button>
  <!-- ─── Scrollable body ─── -->
  <div class="flex-1 overflow-y-auto" id="notif-scroll">

    <!-- ══ NOTIFICATION TAB ══ -->
    <ng-container *ngIf="activeTab === 'notification'">

      <!-- Loading skeleton -->
      <div *ngIf="notifLoading" class="flex flex-col gap-2 p-3">
        <div *ngFor="let i of [1,2,3,4,5]"
          class="flex items-center gap-3 p-3 bg-white rounded-2xl border border-gray-100 animate-pulse">
          <div class="w-10 h-10 rounded-full bg-gray-200 flex-shrink-0"></div>
          <div class="flex-1 space-y-2">
            <div class="h-3 bg-gray-200 rounded w-3/4"></div>
            <div class="h-2.5 bg-gray-100 rounded w-1/2"></div>
          </div>
        </div>
      </div>

      <!-- Error -->
      <div *ngIf="!notifLoading && notifError"
        class="flex flex-col items-center justify-center py-16 gap-3 text-gray-400">
        <svg class="w-10 h-10 opacity-40" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
            d="M12 9v2m0 4h.01M12 3a9 9 0 100 18A9 9 0 0012 3z"/>
        </svg>
        <p class="text-sm">{{ notifError }}</p>
        <button (click)="loadNotifications(false)"
          class="text-xs font-semibold text-[#D31148] hover:underline">Retry</button>
      </div>

      <!-- Groups list -->
      <div *ngIf="!notifLoading && !notifError" class="p-3 flex flex-col gap-2">

        <div *ngFor="let group of groups; trackBy: trackByGroupKey"
          class="rounded-2xl border transition-all duration-150 overflow-hidden cursor-pointer"
          [class.bg-white]="group.isRead"
          [class.bg-[#FFF5F7]]="!group.isRead"
          [class.border-gray-100]="group.isRead"
          [class.border-[#FBCFD8]]="!group.isRead"
          (click)="onGroupClick(group)">

          <!-- Main row -->
          <div class="flex items-start gap-3 px-4 py-3">

            <!-- Avatar stack (2 overlapping) -->
            <div class="relative flex-shrink-0 w-12 h-10 mt-0.5">
              <img *ngIf="group.senders[0]"
                [src]="avatarUrl(group.senders[0])"
                [alt]="group.senders[0].displayName"
                class="w-10 h-10 rounded-full object-cover ring-2 ring-white shadow absolute left-0 top-0"/>
              <img *ngIf="group.senders[1]"
                [src]="avatarUrl(group.senders[1])"
                [alt]="group.senders[1].displayName"
                class="w-7 h-7 rounded-full object-cover ring-2 ring-white shadow absolute -right-1 -bottom-1"/>
            </div>

            <!-- Text -->
            <div class="flex-1 min-w-0">
              <p class="text-sm leading-snug"
                [class.font-semibold]="!group.isRead"
                [class.font-normal]="group.isRead"
                [class.text-gray-900]="!group.isRead"
                [class.text-gray-500]="group.isRead">
                {{ group.message }}
              </p>
              <p class="text-xs text-gray-400 mt-0.5">{{ timeAgo(group.createdAt) }}</p>
            </div>

            <!-- Content thumbnail (post/blog/event media) for like/comment/mention/collab notifications -->
            <img *ngIf="thumbnailUrl(group)"
              [src]="thumbnailUrl(group)"
              [alt]="captionText(group)"
              class="w-11 h-11 rounded-lg object-cover flex-shrink-0 ring-1 ring-gray-100 mt-0.5"/>

            <!-- Unread dot + chevron -->
            <div class="flex-shrink-0 mt-1.5 flex items-center gap-1">
              <span *ngIf="!group.isRead"
                class="w-2.5 h-2.5 rounded-full bg-[#D31148] block"></span>
              <svg *ngIf="group.actorCount > 1"
                class="w-4 h-4 text-gray-300 transition-transform duration-200"
                [class.rotate-180]="expandedGroup === group.groupKey"
                fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/>
              </svg>
            </div>
          </div>

          <!-- Collaboration invite: inline Accept / Decline buttons -->
          <!-- <div *ngIf="isCollabNotification(group) && !getCollabActionStatus(group)"
            class="px-4 pb-3 flex gap-2" (click)="$event.stopPropagation()">
            <button (click)="acceptCollab(group, $event)"
              [disabled]="collabActioningId === group.groupKey"
              class="flex-1 flex items-center justify-center gap-1.5 py-1.5 rounded-xl bg-[#D31148] text-white text-xs font-semibold disabled:opacity-50 hover:bg-[#b50e3c] transition-colors">
              <svg *ngIf="collabActioningId !== group.groupKey" width="12" height="12" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              <svg *ngIf="collabActioningId === group.groupKey" class="animate-spin" width="12" height="12"
                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
              </svg>
              Accept
            </button>
            <button (click)="declineCollab(group, $event)"
              [disabled]="collabActioningId === group.groupKey"
              class="flex-1 flex items-center justify-center gap-1.5 py-1.5 rounded-xl border border-gray-200 bg-white text-gray-600 text-xs font-semibold disabled:opacity-50 hover:bg-gray-50 transition-colors">
              <svg *ngIf="collabActioningId !== group.groupKey" width="12" height="12" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
              Decline
            </button>
          </div> -->

          <!-- Collaboration result: accepted / declined feedback -->
          <div *ngIf="isCollabNotification(group) && getCollabActionStatus(group) === 'ACCEPTED'"
            class="px-4 pb-3 flex items-center gap-2" (click)="$event.stopPropagation()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#059669" stroke-width="2.5"
              stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
            <span class="text-xs font-semibold text-emerald-700">Collaboration accepted</span>
          </div>
          <div *ngIf="isCollabNotification(group) && getCollabActionStatus(group) === 'DECLINED'"
            class="px-4 pb-3 flex items-center gap-2" (click)="$event.stopPropagation()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#dc2626" stroke-width="2.5"
              stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
            <span class="text-xs font-semibold text-red-600">Collaboration declined</span>
          </div>

          <!-- Expanded actor list (inline, shows first 3) -->
          <div *ngIf="expandedGroup === group.groupKey && group.actorCount > 1"
            class="border-t border-gray-100 bg-gray-50 px-4 py-3 flex flex-col gap-2.5"
            (click)="$event.stopPropagation()">

            <p class="text-xs text-gray-400 font-semibold uppercase tracking-wide mb-1">
              {{ group.actorCount }} {{ group.actorCount === 1 ? 'person' : 'people' }}
            </p>

            <div *ngFor="let sender of group.senders.slice(0, 3); trackBy: trackBySenderId"
              class="flex items-center gap-2.5 cursor-pointer hover:opacity-75 transition-opacity"
              (click)="router.navigate(['/profile', sender.userName, 'post']); closePanel()">
              <img [src]="avatarUrl(sender)" [alt]="sender.displayName"
                class="w-8 h-8 rounded-full object-cover ring-1 ring-white shadow-sm flex-shrink-0"/>
              <div class="min-w-0">
                <p class="text-sm font-semibold text-gray-800 leading-tight truncate">
                  {{ sender.displayName }}
                </p>
                <p class="text-xs text-gray-400 truncate">@{{ sender.userName }}</p>
              </div>
            </div>

            <!-- View all (when more than 3 actors) — opens modal -->
            <button *ngIf="group.actorCount > 3"
              (click)="openActorModal(group, $event)"
              class="text-xs text-[#D31148] font-semibold text-left hover:underline mt-1 flex items-center gap-1">
              <svg class="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857
                     M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857
                     m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
              View all {{ group.actorCount }} people
            </button>
          </div>
        </div>

        <!-- Empty state -->
        <div *ngIf="groups.length === 0"
          class="flex flex-col items-center justify-center py-20 text-gray-400 gap-3">
          <svg class="w-14 h-14 opacity-30" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5
                 a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436
                 L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
          </svg>
          <p class="text-sm font-medium">You're all caught up!</p>
        </div>

        <!-- Load more button -->
        <div *ngIf="hasMoreNotifications" class="pt-1 pb-2 flex justify-center">
          <button (click)="loadMoreNotifications()"
            [disabled]="notifLoadingMore"
            class="flex items-center gap-2 px-5 py-2 rounded-xl border border-gray-200 bg-white
                   text-sm font-semibold text-gray-600 hover:border-[#D31148] hover:text-[#D31148]
                   transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
            <svg *ngIf="notifLoadingMore" class="w-4 h-4 animate-spin text-[#D31148]"
              fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
            </svg>
            <span>{{ notifLoadingMore ? 'Loading…' : 'Load more' }}</span>
          </button>
        </div>
      </div>
    </ng-container>

    <!-- ══ FRIEND REQUEST TAB ══ -->
    <ng-container *ngIf="activeTab === 'friend'">

      <!-- Loading skeleton -->
      <div *ngIf="friendLoading" class="flex flex-col gap-3 p-4">
        <div *ngFor="let i of [1,2,3]"
          class="flex items-center gap-3 p-4 bg-white rounded-2xl border border-gray-100 animate-pulse">
          <div class="w-12 h-12 rounded-full bg-gray-200 flex-shrink-0"></div>
          <div class="flex-1 space-y-2">
            <div class="h-3 bg-gray-200 rounded w-2/3"></div>
            <div class="h-2.5 bg-gray-100 rounded w-1/3"></div>
          </div>
          <div class="flex gap-2">
            <div class="w-16 h-7 bg-gray-200 rounded-lg"></div>
            <div class="w-16 h-7 bg-gray-100 rounded-lg"></div>
          </div>
        </div>
      </div>

      <!-- Error -->
      <div *ngIf="!friendLoading && friendError"
        class="flex flex-col items-center justify-center py-16 gap-3 text-gray-400">
        <p class="text-sm">{{ friendError }}</p>
        <button (click)="loadFriendRequests()"
          class="text-xs font-semibold text-[#D31148] hover:underline">Retry</button>
      </div>

      <!-- Friend request list -->
      <div *ngIf="!friendLoading && !friendError" class="p-3 flex flex-col gap-2">

        <div *ngFor="let req of friendReqs; trackBy: trackByReqId"
          class="flex items-center gap-3 px-4 py-3.5 bg-white rounded-2xl border border-gray-100
                 hover:border-gray-200 transition-colors">

          <!-- Avatar — click to profile -->
          <img [src]="avatarUrl(req.sender)"
            [alt]="req.sender.displayName"
            class="w-12 h-12 rounded-full object-cover ring-2 ring-white shadow flex-shrink-0 cursor-pointer"
            (click)="router.navigate(['/profile', req.sender.userName, 'post']); closePanel()"/>

          <!-- Info -->
          <div class="flex-1 min-w-0 cursor-pointer"
            (click)="router.navigate(['/profile', req.sender.userName, 'post']); closePanel()">
            <p class="font-semibold text-gray-900 text-sm leading-tight truncate">
              {{ req.sender.displayName }}
            </p>
            <p class="text-gray-400 text-xs mt-0.5 truncate">@{{ req.sender.userName }}</p>

            <!-- ── Mutual friends row ── -->
            <ng-container *ngIf="req.mutualFriendCount > 0">
              <div class="flex items-center gap-1 mt-1" (click)="$event.stopPropagation()">

                <!-- Mini avatar stack (up to 2) -->
                <div class="relative flex items-center"
                  [style.width.px]="(req.mutualFriends.length >= 2 ? 28 : 16)">
                  <img *ngIf="req.mutualFriends[0]"
                    [src]="avatarUrl(req.mutualFriends[0])"
                    [alt]="req.mutualFriends[0].displayName"
                    class="w-4 h-4 rounded-full object-cover ring-1 ring-white absolute left-0"/>
                  <img *ngIf="req.mutualFriends[1]"
                    [src]="avatarUrl(req.mutualFriends[1])"
                    [alt]="req.mutualFriends[1].displayName"
                    class="w-4 h-4 rounded-full object-cover ring-1 ring-white absolute left-2.5"/>
                </div>

                <!-- Label — plain text when ≤2 mutuals, clickable when 3+ -->
                <span *ngIf="req.mutualFriendCount < 3"
                  class="text-xs text-gray-400 ml-1">
                  {{ mutualLabel(req) }}
                </span>

                <button *ngIf="req.mutualFriendCount >= 3"
                  (click)="openMutualModal(req, $event)"
                  class="text-xs text-gray-500 hover:text-[#D31148] transition-colors ml-1 text-left">
                  <span class="font-medium text-gray-700">{{ req.mutualFriends[0]?.userName }}</span>
                  <span> and </span>
                  <span class="font-medium text-[#D31148] hover:underline">
                    {{ req.mutualFriendCount - 1 }} others
                  </span>
                </button>
              </div>
            </ng-container>
          </div>

          <!-- Accept / Decline -->
          <div class="flex flex-col gap-1.5 flex-shrink-0">
            <button (click)="acceptRequest(req)"
              class="px-4 py-1.5 bg-[#D31148] hover:bg-[#a00f38] text-white text-xs
                     font-semibold rounded-lg transition-colors">
              Accept
            </button>
            <button (click)="declineRequest(req)"
              class="px-4 py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-600 text-xs
                     font-semibold rounded-lg transition-colors">
              Decline
            </button>
            <button (click)="declineAndBlockRequest(req)"
              [disabled]="declineAndBlockActioningId === req._id"
              class="px-4 py-1.5 bg-white border border-red-200 hover:bg-red-50 text-red-600 text-xs
                     font-semibold rounded-lg transition-colors disabled:opacity-50">
              {{ declineAndBlockActioningId === req._id ? 'Blocking…' : 'Decline & Block' }}
            </button>
          </div>
        </div>

        <!-- Empty state -->
        <div *ngIf="friendReqs.length === 0"
          class="flex flex-col items-center justify-center py-20 text-gray-400 gap-3">
          <svg class="w-14 h-14 opacity-30" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"
              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857
                 M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857
                 m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
          </svg>
          <p class="text-sm font-medium">No pending friend requests</p>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- ─── Backdrop ─── -->
<div *ngIf="isOpen"
  class="fixed inset-0 z-[99998] bg-black/40"
  (click)="closePanel()">
</div>

<!-- ─── Actor modal (View all X people) ─── -->
<div *ngIf="actorModalGroup"
  class="fixed inset-0 z-[999999] flex items-center justify-center p-4"
  (click)="closeActorModal()">
  <div class="bg-white rounded-2xl shadow-2xl w-full max-w-sm max-h-[70vh] flex flex-col overflow-hidden"
    (click)="$event.stopPropagation()">

    <!-- Modal header -->
    <div class="flex items-center justify-between px-5 py-4 border-b border-gray-100">
      <p class="font-bold text-gray-900 text-base">
        {{ actorModalGroup.actorCount }} people
      </p>
      <button (click)="closeActorModal()"
        class="p-1.5 rounded-lg text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-colors">
        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <!-- Modal body — full sender list -->
    <div class="overflow-y-auto flex-1 px-4 py-3 flex flex-col gap-2">
      <div *ngFor="let sender of actorModalGroup.senders; trackBy: trackBySenderId"
        class="flex items-center gap-3 py-2 cursor-pointer hover:opacity-75 transition-opacity"
        (click)="router.navigate(['/profile', sender.userName, 'post']); closeActorModal(); closePanel()">
        <img [src]="avatarUrl(sender)" [alt]="sender.displayName"
          class="w-10 h-10 rounded-full object-cover ring-1 ring-gray-100 shadow-sm flex-shrink-0"/>
        <div class="min-w-0">
          <p class="text-sm font-semibold text-gray-900 leading-tight truncate">
            {{ sender.displayName }}
          </p>
          <p class="text-xs text-gray-400 truncate">@{{ sender.userName }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ─── Mutual friends popup modal ─── -->
<div *ngIf="mutualModalReq"
  class="fixed inset-0 z-[999999] flex items-center justify-center p-4"
  (click)="closeMutualModal()">
  <div class="bg-white rounded-2xl shadow-2xl w-full max-w-sm max-h-[70vh] flex flex-col overflow-hidden"
    (click)="$event.stopPropagation()">

    <!-- Modal header -->
    <div class="flex items-center justify-between px-5 py-4 border-b border-gray-100">
      <div>
        <p class="font-bold text-gray-900 text-base">Mutual Friends</p>
        <p class="text-xs text-gray-400 mt-0.5">
          {{ mutualModalReq.mutualFriendCount }}
          mutual friend{{ mutualModalReq.mutualFriendCount !== 1 ? 's' : '' }}
          with {{ mutualModalReq.sender.displayName }}
        </p>
      </div>
      <button (click)="closeMutualModal()"
        class="p-1.5 rounded-lg text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-colors">
        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <!-- Loading spinner -->
    <div *ngIf="mutualModalLoading"
      class="flex items-center justify-center py-12">
      <svg class="w-7 h-7 animate-spin text-[#D31148]" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
      </svg>
    </div>

    <!-- Mutual friends list -->
    <div *ngIf="!mutualModalLoading"
      class="overflow-y-auto flex-1 px-4 py-3 flex flex-col gap-1">
      <div *ngFor="let mutual of mutualModalFriends; trackBy: trackByMutualId"
        class="flex items-center gap-3 py-2.5 cursor-pointer hover:bg-gray-50 rounded-xl px-2 transition-colors"
        (click)="router.navigate(['/profile', mutual.userName, 'post']); closeMutualModal(); closePanel()">
        <img [src]="avatarUrl(mutual)" [alt]="mutual.displayName"
          class="w-10 h-10 rounded-full object-cover ring-1 ring-gray-100 shadow-sm flex-shrink-0"/>
        <div class="min-w-0">
          <p class="text-sm font-semibold text-gray-900 leading-tight truncate">
            {{ mutual.displayName }}
          </p>
          <p class="text-xs text-gray-400 truncate">@{{ mutual.userName }}</p>
        </div>
        <!-- Chevron hint -->
        <svg class="w-4 h-4 text-gray-300 flex-shrink-0 ml-auto" fill="none" viewBox="0 0 24 24"
          stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/>
        </svg>
      </div>

      <!-- Empty fallback -->
      <div *ngIf="mutualModalFriends.length === 0"
        class="flex flex-col items-center justify-center py-10 text-gray-400 gap-2">
        <p class="text-sm">No mutual friends found</p>
      </div>
    </div>
  </div>
</div>